import React from 'react';
import { Modal } from 'react-bootstrap';
import Clock from '../../../../../../src/assets/svg_main/clock-01.svg';
import InfoBar from '@components/common/InfoBars';
import './ChildAddServicesModal.css';


interface ErrorObject {
  showError: boolean;
  errorMessage: string;
  errorField: string;
  isDisable: boolean;
}

interface ChildAddServicesModalProps {
  showModal: boolean;
  onClose: () => void;
  modalTitle: string;
  modalSubTitle:string
  content:any;
  handleItemClick: (item: string) => void;
  handleBack:(modalTitle:string) => void;
  errors?: ErrorObject[];
}


const ChildAddServicesModal = (props:ChildAddServicesModalProps) => {
  const {showModal, onClose, modalTitle, modalSubTitle, content, handleItemClick, handleBack, errors } = props;

  const getErrorForField = (field: string) => {
    return errors?.find(error => error.errorField === field);
  };

  return (
    <div className="child-add-service-modal">
      <Modal
        show={showModal}
        onHide={onClose}
        dialogClassName={'child-add-service-modal'}
        centered={true}
        backdrop = "static"
      >
        <Modal.Body>
          <div className="child-add-service-modal-body-header">
            <div className="modal-body-back" onClick={() => handleBack(modalTitle)}>
            <i className="bi bi-arrow-left"></i>
            </div>
            <div className="modal-body-discard" onClick={onClose}>
            <i className="bi bi-x"></i>
            </div>
          </div>
          <div className="child-add-service-modal-title">
            <h1>{modalTitle}</h1>
            <h3>{modalSubTitle}</h3>

            <div className="child-add-service-modal-info">
              {content?.map((item:any)=>{
                const error = getErrorForField(item);
                return(
                  <div key={item}>
                      <div 
                      key= {item}
                      className={`child-add-service-modal-data ${error?.isDisable ? 'child-add-service-modal-disabled' : '' }`}
                      onClick={!error?.isDisable ? () => handleItemClick(item) : undefined} 
                    >
                      <div className='child-add-service-modal-icon' >
                        <span><Clock/></span>
                        <p>{item}</p>
                      </div>
                      <span>+</span>
                    </div>
                    {error?.showError && <InfoBar
                      variant="danger"
                      message={error.errorMessage}
                      className="input_field_class"
                    />}
                  </div>
                )
              })}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default ChildAddServicesModal